import React from 'react';
import { useData } from '../context/DataContext';
import '../styles/Home.css';

function Home() {
  const { loading, error } = useData();

  if (loading) {
    return (
      <section className="home">
        <div className="hero">
          <h1>Trickle Down Economics: A 40-Year Failure</h1>
          <p className="subtitle">Loading wealth inequality data...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="home">
        <div className="hero">
          <h1>Trickle Down Economics: A 40-Year Failure</h1>
          <p className="subtitle">Error loading data. Please try again later.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="home">
      <div className="hero">
        <h1>Trickle Down Economics: A 40-Year Failure</h1>
        <p className="subtitle">Exposing how wealth flows up, not down</p>
        <div className="scroll-prompt">
          <p>Scroll to see the evidence</p>
          <span className="arrow">↓</span>
        </div>
      </div>
    </section>
  );
}

export default Home; 